module.exports = __webpack_public_path__ + "img/HeadCircuit.7c6c8f0e.svg";